import { render, staticRenderFns } from "./product-filter.vue?vue&type=template&id=31b5ac2a&scoped=true&lang=pug&"
import script from "./product-filter.vue?vue&type=script&lang=coffee&"
export * from "./product-filter.vue?vue&type=script&lang=coffee&"
import style0 from "./product-filter.vue?vue&type=style&index=0&id=31b5ac2a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b5ac2a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormCheckbox: require('/opt/build/repo/library/components/globals/form/checkbox.vue').default,PlpFeaturedProductCard: require('/opt/build/repo/nuxt-app/components/pages/plp/featured-product-card.vue').default,CardsProductCard: require('/opt/build/repo/nuxt-app/components/globals/cards/product/product-card.vue').default,Btn: require('/opt/build/repo/nuxt-app/components/globals/btn/btn.vue').default,FilterableList: require('/opt/build/repo/library/components/globals/filterable-list/filterable-list.vue').default})
